import { STATUS } from "../Settlement/components/constants/status";

export const status = (
    value: string | null | undefined
) => {
    if (typeof value !== 'string') {
        return value;
    }
    switch (value) {
        case STATUS.REQUEST:
            return '확인요청';
        case STATUS.WAITING:
            return '결제대기';
        case STATUS.COMPLETED:
            return '결제완료';
        default:
            return '';
    }
};

export const inquiryStatus = (
    value: string | null | undefined
) => {
    if (typeof value !== 'string') {
        return value;
    }
    switch (value) {
        case STATUS.NEW:
            return '결제요청전';
        case STATUS.REQUEST:
            return '결제전';
        case STATUS.COMPLETED:
            return '결제완료';
        default:
            return '';
    }
};